import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';

/**
 * The card of every dashboard list page (Leads, Customers, Businesses,
 * Roles...): it fills the page body under the header (PageLayout /
 * BoundedPageLayout) whatever the number of rows, and its DataGrid gets the
 * full height — the grid scrolls its own rows (virtualized) and keeps the
 * toolbar and the pagination footer visible.
 *
 * Put a DataGrid inside WITHOUT `autoHeight` (its height comes from here),
 * or the mobile fallback (a List), which scrolls inside the card. Keep this
 * the single place for the list layout.
 *
 * `note`: optional footer under the grid (same as MetricCard's), e.g. how the
 * filters work.
 */
export default function DataGridCard({ children, note, sx }) {
  return (
    <Card
      sx={{
        width: '100%',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        minHeight: 0,
        ...sx,
      }}
    >
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: 'auto',
          '& > .MuiDataGrid-root': {
            height: '100%',
            // Com CSS vars o MUI X fixa o fundo do cabeçalho em background.default
            // (a cor da página), que dentro do card parece um buraco. Usa a cor do
            // próprio card: papel + camada da elevação 1 (só existe no dark; no
            // light a variável não existe e vale o `none`).
            '--DataGrid-containerBackground':
              'var(--mui-overlays-1, none), var(--mui-palette-background-paper)',
            '--DataGrid-pinnedBackground': 'var(--mui-palette-background-paper)',
          },
        }}
      >
        {children}
      </Box>
      {note && (
        <>
          <Divider />
          <Box sx={{ px: 2, py: 1.5 }}>{note}</Box>
        </>
      )}
    </Card>
  );
}
